import React from 'react';

export type WorkOrderStatus =
  | 'Aberta' |'Aguardando Aprovação' |'Aprovada' |'Atribuída' |'Em Execução' |'Pendente Material' |'Concluída' |'Encerrada' |'Cancelada';

export type PriorityLevel = 'Crítica' | 'Alta' | 'Média' | 'Baixa';

const statusStyles: Record<WorkOrderStatus, string> = {
  'Aberta':               'bg-blue-50 text-blue-700 ring-1 ring-blue-200',
  'Aguardando Aprovação': 'bg-violet-50 text-violet-700 ring-1 ring-violet-200',
  'Aprovada':             'bg-purple-50 text-purple-700 ring-1 ring-purple-200',
  'Atribuída':            'bg-amber-50 text-amber-700 ring-1 ring-amber-200',
  'Em Execução':          'bg-sky-50 text-sky-700 ring-1 ring-sky-200',
  'Pendente Material':    'bg-red-50 text-red-700 ring-1 ring-red-200',
  'Concluída':            'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200',
  'Encerrada':            'bg-gray-100 text-gray-600 ring-1 ring-gray-200',
  'Cancelada':            'bg-gray-100 text-gray-400 ring-1 ring-gray-200',
};

const priorityStyles: Record<PriorityLevel, string> = {
  'Crítica': 'bg-red-100 text-red-700',
  'Alta':    'bg-orange-100 text-orange-700',
  'Média':   'bg-amber-100 text-amber-700',
  'Baixa':   'bg-green-100 text-green-700',
};

interface StatusBadgeProps {
  status: WorkOrderStatus;
  className?: string;
}

export function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  return (
    <span className={`status-badge ${statusStyles[status]} ${className}`}>
      {status}
    </span>
  );
}

interface PriorityBadgeProps {
  priority: PriorityLevel;
  className?: string;
}

export function PriorityBadge({ priority, className = '' }: PriorityBadgeProps) {
  return (
    <span className={`priority-badge ${priorityStyles[priority]} ${className}`}>
      {priority}
    </span>
  );
}